/** Public Statuspage API v2 shapes used by the in-app status banner. */

export const STATUS_PAGE_SUMMARY_URL = 'https://status.modernloop.io/api/v2/summary.json';

export const STATUS_PAGE_IMPACT_SEVERITY = {
  critical: 4,
  major: 3,
  minor: 2,
  none: 1,
} as const;

export type StatusPageImpact = keyof typeof STATUS_PAGE_IMPACT_SEVERITY;

export interface StatusPageComponent {
  id: string;
  name: string;
  status: string;
}

export interface StatusPageIncident {
  id: string;
  name: string;
  status: string;
  impact: StatusPageImpact;
  shortlink: string;
  components: StatusPageComponent[];
}

export interface StatusPageScheduledMaintenance {
  id: string;
  name: string;
  status: string;
  impact: StatusPageImpact;
  shortlink: string;
  scheduled_for: string;
  scheduled_until: string;
  components: StatusPageComponent[];
}

export interface StatusPageSummaryResponse {
  page: {
    url: string;
  };
  incidents: StatusPageIncident[];
  scheduled_maintenances: StatusPageScheduledMaintenance[];
}

export type StatusPageBannerItem =
  | { type: 'INCIDENT'; item: StatusPageIncident }
  | { type: 'MAINTENANCE'; item: StatusPageScheduledMaintenance };

export interface StatusPageBannerConfig {
  componentIds?: string[];
}
